import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

/*
  Organization
 */
export const getReviewFormApi = ({
  formName,
  employeeId,
  reviewId,
  providerId,
  responseId,
  providerType,
  isPreview,
  previewSubmissionStatus,
}) => {
  const url = endpoints.performanceReview.reviewForm;

  const queryParams = {
    form_name: formName,
    review_id: reviewId,
    emp_id: employeeId,
    isPreview,
    previewResponseProviderType: providerType,
    previewSubmissionStatus,
  };

  // In case of Anonymous Provider, we're passing response_id instead of provider_id
  if (providerId) {
    queryParams.provider_id = providerId;
  } else {
    queryParams.response_id = responseId;
  }

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
};

export const getSummaryStatsApi = ({
  employeeId,
  reviewId,
  providerId,
  useOldEndpoint = false,
  isPreview,
  providerType,
  previewSubmissionStatus,
}) => {
  const url = useOldEndpoint ? endpoints.performanceReview.summaryStatsOld : endpoints.performanceReview.summaryStats;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
      provider_id: providerId,
      isPreview,
      previewResponseProviderType: providerType,
      previewSubmissionStatus,
    },
  });
};

export const getReviewPeriodSummaryGoalsApi = ({ employeeId, reviewId }) => {
  const url = endpoints.performanceReview.reviewPeriodSummaryGoals;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
    },
  });
};

export const getPerformancePreviewApi = ({ empId }) => {
  const url = endpoints.performanceReview.performancePreview;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      empId,
    },
  });
};

export const updateQuestionResponseApi = ({ responseBody, employeeId, goalId, competencyId, reviewId, isPreview }) => {
  const url = endpoints.performanceReview.reviewFormPut;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
      goal_id: goalId,
      competency_id: competencyId,
      isPreview,
    },
    body: responseBody,
  });
};

export const getActiveReviewsApi = ({ limit, offset, includeCount }) => {
  const url = endpoints.performanceReview.activeReviews;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      include_count: includeCount,
    },
  });
};

export const getArchivedReviewsApi = ({ limit, offset, includeCount }) => {
  const url = endpoints.performanceReview.archivedReviews;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      include_count: includeCount,
    },
  });
};

export const getTeamReviewsApi = ({ limit, offset, requestedReviewCycle }) => {
  const url = endpoints.performanceReview.teamReviews;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      requested_review_cycle: requestedReviewCycle,
    },
  });
};

export const getRequestedReviewsApi = ({ limit, offset, includeCount }) => {
  const url = endpoints.performanceReview.requestedReviews;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      include_count: includeCount,
    },
  });
};

export const getPeerFeedbackApi = ({
  goalId,
  competencyId,
  questionId,
  employeeId,
  reviewId,
  providerType,
  isPreview,
  previewSubmissionStatus,
}) => {
  const url = endpoints.performanceReview.peerFeedback;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      goal_id: goalId,
      competency_id: competencyId,
      question_id: questionId,
      review_id: reviewId,
      emp_id: employeeId,
      isPreview,
      previewResponseProviderType: providerType,
      previewSubmissionStatus,
    },
  });
};

export const submitReviewApi = ({ employeeId, reviewId }) => {
  const url = endpoints.performanceReview.submitReview;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
    },
  });
};

export const getReviewProvidersApi = ({ employeeId, reviewId, providerType, isPreview, previewSubmissionStatus }) => {
  const url = endpoints.performanceReview.reviewProviders;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
      previewResponseProviderType: providerType,
      isPreview,
      previewSubmissionStatus,
    },
  });
};

export const acknowledgeReviewApi = ({ providerId = null, reviewId }) => {
  const url = endpoints.performanceReview.acknowledge;
  const queryParams = {
    review_id: reviewId,
  };
  if (providerId) {
    queryParams.provider_id = providerId;
  }
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams,
  });
};

// export const getNominatedPeersApi = ({ reviewId, empId }) => {
//   const url = endpoints.performanceReview.nominatePeers;
//   return sendRequest({
//     url,
//     method: 'GET',
//     credentials: 'include',
//     queryParams: {
//       review_id: reviewId,
//       emp_id: empId
//     }
//   });
// };

export const getAllNominationsApi = ({ reviewId, empId }) => {
  const url = endpoints.performanceReview.nominatedPeers;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: empId,
    },
  });
};

// export const getDLMNominatedPeersApi = ({ reviewId }) => {
//   const url = endpoints.performanceReview.nominatePeersDLM;
//   return sendRequest({
//     url,
//     method: 'GET',
//     credentials: 'include',
//     queryParams: {
//       review_id: reviewId
//     }
//   });
// };

export const getPeerPoolApi = ({ reviewId, empId }) => {
  const url = endpoints.performanceReview.peerPoolDetails;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: empId,
    },
  });
};

export const nominatePeerApi = ({ employees, reviewId, empId }) => {
  const url = endpoints.performanceReview.nominatePeers;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: empId,
    },
    body: employees,
  });
};

export const nominateDLMApi = ({ reviewId, empId, dlmEmpId }) => {
  const url = endpoints.performanceReview.nominatePeersDLM;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      dlm_emp_id: dlmEmpId,
      emp_id: empId,
    },
  });
};

export const withdrawDLMNominationApi = ({ reviewId, empId, dlmEmpId }) => {
  const url = endpoints.performanceReview.nominatePeersDLM;
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      provider_emp_id: dlmEmpId,
      emp_id: empId,
    },
  });
};

export const acceptNominationApi = ({ employeeId, reviewId, isDLM = false }) => {
  const url = isDLM ? endpoints.performanceReview.acceptDLMNomination : endpoints.performanceReview.acceptNomination;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
    },
  });
};

export const rejectNominationApi = ({ employeeId, reviewId, isDLM = false }) => {
  const url = isDLM ? endpoints.performanceReview.rejectDLMNomination : endpoints.performanceReview.rejectNomination;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
    },
  });
};

export const withdrawNominationApi = ({ reviewId, providerEmpId, empId = null }) => {
  const url = endpoints.performanceReview.withdrawNomination;
  const queryParams = {
    review_id: reviewId,
    provider_emp_id: providerEmpId,
  };
  if (empId) {
    queryParams.emp_id = empId;
  }
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams,
  });
};

export const getPeerStatusApi = () => {
  const url = endpoints.performanceReview.peerStatus;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getUpwardStatusApi = () => {
  const url = endpoints.performanceReview.upwardStatus;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getActiveReviewsCountApi = () => {
  const url = endpoints.performanceReview.activeReviewsCount;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getPastFeedbacksApi = ({ offset, limit, includeCount, receiverEmployeeId }) => {
  const url = endpoints.performanceReview.pastFeedbacks;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      offset,
      limit,
      include_count: includeCount,
      receiver_employee_id: receiverEmployeeId,
    },
  });
};

export const getReviewHelpDocumentsApi = ({ reviewId }) => {
  const url = endpoints.performanceReview.documents;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
    },
  });
};

export const getReviewHelpFAQsApi = ({ reviewId }) => {
  const url = endpoints.performanceReview.faqs;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
    },
  });
};
export const getReviewHelpTimelineApi = ({ reviewId }) => {
  const url = endpoints.performanceReview.timeline;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
    },
  });
};

export const getReviewHelpTimelineApiV1 = ({ reviewCycleId }) => {
  const url = endpoints.performanceReview.timelineV1;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      reviewCycleId,
    },
  });
};

export const publishReview = ({ reviewCycleId, empId, cohortId }) => {
  const url = endpoints.analytics.review.partialPublish.publish;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      reviewCycleId,
      employeesList: [empId],
      cohortId,
      publishStatus: 'PUBLISHED',
    },
    queryParams: {},
  });
};

export const unPublishReview = ({ reviewCycleId, empId, cohortId }) => {
  const url = endpoints.performanceReview.unpublish;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
      receiver_employee_id: empId,
      cohort_id: cohortId,
    },
  });
};

export const getReviewGoalsApi = ({ employeeId, reviewId, providerId }) => {
  const url = endpoints.performanceReview.reviewGoals;

  const queryParams = {
    provider_id: providerId,
    review_id: reviewId,
    emp_id: employeeId,
  };

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
};

// rabbit APIs

export const getReviewResponseApiV1 = ({
  goalId,
  competencyId,
  questionId,
  reviewId,
  employeeId,
  excludeEmployeeId,
  providerType,
  isPreview,
  previewSubmissionStatus,
}) => {
  const url = endpoints.performanceReview.reviewResponseV1;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      question_id: questionId,
      emp_id: employeeId,
      review_id: reviewId,
      goal_id: goalId,
      competency_id: competencyId,
      exclude_employee_id: excludeEmployeeId,
      previewResponseProviderType: providerType,
      isPreview,
      previewSubmissionStatus,
    },
  });
};

export const getReviewFormApiV1 = ({
  formName,
  employeeId,
  reviewId,
  providerType,
  isPreview,
  previewSubmissionStatus,
}) => {
  const url = endpoints.performanceReview.reviewFormV1;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      form_name: formName,
      emp_id: employeeId,
      review_id: reviewId,
      previewResponseProviderType: providerType,
      isPreview,
      previewSubmissionStatus,
    },
  });
};

export const getReviewsSectionsDataApi = () => {
  const url = endpoints.performanceReview.reviewFormsSections;

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getReviewFormsListApi = ({ reviewCycleId, sectionId, limit, offset, includeCount }) => {
  const url = endpoints.performanceReview.reviewFormsList;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      ...(reviewCycleId && { review_cycle_id: reviewCycleId }),
      section_id: sectionId,
      include_count: includeCount,
    },
  });
};

export const getReviewTableCSVReportApi = ({ sectionId }) => {
  const url = endpoints.performanceReview.reviewTableCSVReport;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      section_id: sectionId,
    },
  });
};

export function updateReviewGoalsWeightageApi({ employeeId, formId, body }) {
  const url = endpoints.performanceReview.updateReviewOkrsWeightage;
  return sendRequest({
    url,
    method: 'PUT',
    queryParams: {
      empId: employeeId,
      ...(formId && { formId }),
    },
    body,
    credentials: 'include',
  });
}

export const getFormatFeedbackFormTextApi = ({
  reviewId,
  empId,
  questionId,
  groupId,
  revisionNumber,
  feedbackText,
  rephraseInstruction,
}) => {
  const url = endpoints.performanceReview.textAnalysis.formatFeedbackFormText;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    queryParams: {
      reviewId,
      emp_id: empId,
    },
    body: {
      questionId,
      groupId,
      revisionNumber,
      feedbackText,
      rephraseInstruction,
    },
  });
};

export const getTextAnalysisApi = ({ reviewId, empId, groupId, revisionNumber, feedbackText }) => {
  const url = endpoints.performanceReview.textAnalysis.analyzeText;
  return sendRequest({
    url,
    credentials: 'include',
    method: 'POST',
    queryParams: {
      reviewId,
      emp_id: empId,
    },
    body: {
      groupId,
      revisionNumber,
      feedbackText,
    },
  });
};

// export const getAIManagerSummaryApi = ({
//   reviewId,
//   empId,
//   questionId,
//   goalText,
//   goalProgressLevel,
//   competencyText,
//   competencyId,
//   competencyDescription,
//   goalId
// }) => {
//   let url = endpoints.performanceReview.aIManagerSummary.questionResponseSummary;
//   return sendRequest({
//     url,
//     credentials: 'include',
//     queryParams: {
//       review_id: reviewId,
//       emp_id: empId,
//       question_id: questionId,
//       goal_text: goalText,
//       goal_progress_level: goalProgressLevel,
//       competency_description: competencyDescription,
//       competency_text: competencyText,
//       competency_id: competencyId,
//       goal_id: goalId,
//       is_manager_summary_required: true
//       // competency_id: competencyId
//     }
//   });
// };

export const getAIManagerSummaryPointsApi = ({
  reviewId,
  empId,
  questionId,
  goalText,
  goalProgressLevel,
  competencyText,
  competencyId,
  competencyDescription,
  goalId,
}) => {
  const url = endpoints.performanceReview.aIManagerSummary.questionSummaryPoints;

  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: empId,
      question_id: questionId,
      goal_text: goalText,
      goal_progress_level: goalProgressLevel,
      competency_description: competencyDescription,
      competency_text: competencyText,
      competency_id: competencyId,
      goal_id: goalId,
      is_manager_summary_required: true,
    },
  });
};

export const postAIManagerSummaryFeedbackApi = ({
  questionId,
  responseId,
  isLike,
  feedbackComment,
  summaryPoints,
  reviewId,
  revieweeId,
}) => {
  const url = endpoints.performanceReview.aIManagerSummary.saveFeedback;

  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      form_id: reviewId,
      emp_id: revieweeId,
    },
    method: 'POST',
    body: {
      questionId,
      responseId,
      isLike,
      feedbackComment,
      summaryPoints,
    },
  });
};
